import { SERVER_API } from "../../Constant";
import axios from "axios";

export const FetchReportByRemittance_api = async (
  startDate: string,
  endDate: string,
  keyword: string = "",
) => {
  try {
    const response = await axios.get(
      `${SERVER_API}/Reports/fetch_report_by_remittance.php`,
      {
        headers: {
          "Content-Type": "application/json",
        },
        params: {
          startDate,
          endDate,
          keyword,
        },
      },
    );

    return response.data;
  } catch (error: any) {
    console.error("Fetch report by remittance failed:", error);
    return { error: "Fetch report by remittance failed" };
  }
};
